export enum GlConstant {
	TIME = 'time',
	DELTA_TIME = 'delta_time',
}
